<template>
  <div>
    <el-card class="box-card">
      授权卡段:
      <template v-if="records.length === 0"> 无 </template>
      <template v-else>
        <span v-for="(item, index) in records" :key="index">
          {{ item.startNum }}--{{ item.endNum }}</span
        >
      </template>
    </el-card>
    <el-tabs type="border-card">
      <el-tab-pane label="全部电卡">
        <electricity-card-manage-one />
      </el-tab-pane> 
      <!-- <el-tab-pane label="转移记录">
        <electricity-card-manage-three />
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
import maintainGetCardNumList from "@/maintain/api/user/card-manage/maintainGetCardNumList";

import ElectricityCardManageOne from "./ElectricityCardManageOne";
// import ElectricityCardManageTwo from "./ElectricityCardManageTwo";
import createdMixin from "@/mixin/createMixin";
// import ElectricityCardManageThree from "./ElectricityCardManageThree";

export default {
  name: "ElectricityCardManage",
  mixins: [createdMixin],
  components: {
    // ElectricityCardManageThree,
    // ElectricityCardManageTwo,
    ElectricityCardManageOne,
  },
  data() {
    return {
      records: [],
    };
  },
  methods: {
    fetchData() {
      maintainGetCardNumList().then((res) => {
        this.records = res.data;
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.box-card
  width: 350px
  margin-bottom: 10px

  span
    margin-left: 5px
</style>
